export default {
  data() {
    return {
      Products: {
        name: {
          Osmanli: 3,
          Matriks: 4,
          MatriksIQ: 5,
          Foreks: 6,
          Ideal: 7,
        },
        type: {
          Desktop: 2,
          Mobile: 3,
          DesktopAndMobile: 1,
        },
        status: {
          requestedPackageID: 6,
        },
      },
    };
  },
  methods: {
    formatPrice(value) {
      const replaceComma = String(value).replace(",", "");
      return this.priceLocalizationNoDecimal(replaceComma, "₺");
    },
    formatPriceNoDecimal(value) {
      const replaceComma = String(value).replace(",", "");
      return this.priceLocalizationNoDecimal(replaceComma);
    },
    formatPriceEuro(value) {
      const replaceComma = String(value).replace(",", "");
      return this.priceLocalizationNoDecimal(replaceComma, "€");
    },
    formatPriceDollar(value) {
      const replaceComma = String(value).replace(",", "");
      return this.priceLocalizationNoDecimal(replaceComma, "$");
    },
    priceLocalization(amount, type) {
      let setType = type === "₺" ? "," : ".";
      if (amount.match(/^\d+(\.\d*)?$/)) {
        return parseInt(Number(amount) * 100, 10)
          .toString()
          .replace(/(..)$/, `${setType}$1`)
          .replace(/(.)(.{15})$/, `$1.$2`)
          .replace(/(.)(.{12})$/, `$1.$2`)
          .replace(/(.)(.{9})$/, `$1.$2`)
          .replace(/(.)(.{6})$/, `$1.$2`);
      }
    },
    priceLocalizationNoDecimal(amount) {
      if (amount.match(/^\d+(\.\d*)?$/)) {
        return parseInt(Number(amount) * 100, 10)
          .toString()
          .replace(/(..)$/, ``)
          .replace(/(.)(.{9})$/, `$1.$2`)
          .replace(/(.)(.{6})$/, `$1.$2`)
          .replace(/(.)(.{3})$/, `$1.$2`);
      }
    },
    integersToCeil(num, comissionLength) {
      let intNum = Math.ceil(num);
      let length = intNum.toString().length;
      let lengthDiff = length - comissionLength;
      if (length > 3) lengthDiff = 3;
      let roundVal = Math.psow(10, lengthDiff);
      return Math.ceil(intNum / roundVal) * roundVal;
    },
    integersToRound(num, comissionLength) {
      let intNum = Math.round(num);
      let length = intNum.toString().length;
      let lengthDiff = length - comissionLength;
      if (length > 3) lengthDiff = 3;
      let roundVal = Math.pow(10, lengthDiff);
      return Math.round(intNum / roundVal) * roundVal;
    },
  },
};
